import Vue from 'vue'
import Vuex from 'vuex'
import { GET_COOKIE } from '../main'
import {
  SOCKET_ONOPEN,
  SOCKET_ONCLOSE,
  SOCKET_ONERROR,
  SOCKET_ONMESSAGE,
  SOCKET_RECONNECT,
  SOCKET_RECONNECT_ERROR
} from './mutation-types'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    timezone : new Date().getTimezoneOffset(),
    alerts : [],
    initialPage: true,
    initial : {
      overlayMenu : false,
      overlayLogin: false,
      slideTo : {
        index : -1,
        speed : ''
      }
    },
    cars : {
      current : {
        index : '',
        id : ''
      },
      list : [],
      state : {
      },
      route : {
      },
      lastSocket : {
        state : {},
        route : {},
        cmd   : {},
        data  : {}
      }
    },
    fuel_type : [
      {
        name : 'Дизель',
        val : 1
      },
      {
        name : 'АИ92',
        val : 3
      },
      {
        name : 'АИ95',
        val : 4
      },
      {
        name : 'АИ98',
        val : 5
      },
    ],
    map : {
      type : 0,
      showChoise: false,
      historyDay : 'empty'
    },
    user : {
      menu : 0,
      isAuthorized : false
    },
    panels : {
      control : 1, // Menu, CarList
      car : 0, // 0 - выключено
      carDetails : false,
      settings : 0,
      option : {
        status : 0,
        type : 0, // UserSetting, Settings, EventList, Commands, SettingsMobicar
      },
      login : {
        status : false,
        type : 'login', // login remindPass newPass userIsCreate
        remind : {}
      }
    },
    commandsName : {
      alarm_start         : "Подать сигнал",
      alarm_stop          : "Отключить сигнал",
      service_start       : "Активировать автосервис",
      service_stop        : "Автосервис отключить",
      pre_heater_start    : "Включить подогреватель",
      pre_heater_stop     : "Отключить подогреватель",

      pre_heater_control  : "Включение предпускового подогревателя",

      arm                 : 'Поставить на охрану',
      disarm              : 'Снять с охраны',
      clear_immo          : "Разрешить поездку",
      door_open           : "Открыть двери",
      door_close          : "Закрыть двери",

      trunk_open          : "Открыть багажник",
      trunk_close         : "Закрыть багажник",
      prog_1              : "Команда 1 допканал",
      prog_2              : "Команда 2 допканал",
      prog_3              : "Команда 3 допканал",
      prog_4              : "Команда 4 допканал",
      prog_5              : "Команда 5 допканал",
      prog_6              : "Команда 6 допканал",
      prog_7              : "Команда 7 допканал",
      prog_8              : "Команда 8 допканал",

      auto_hijack_start   : "Включить защита от",
      auto_hijack_stop    : "Отключить защита от",

      central_lock        : "Центральный замок",

      get_info            : "Обновить статус",
      update_firmware     : "Обновление прошивки устройства",
      update_settings     : "Обновление настроек устройства",
      update_balance      : "Обновление баланса устройства",

      engine_start        : "Завести двигатель",
      engine_stop         : "Остановить двигатель",

      arm_quiet           : "Тихое включение режима Охраны",
      disarm_quiet        : "Тихое выключение режима Охраны",
      ign_support_on      : "Включение поддержки зажигания",
      panic_stop          : "Остановить Панику",
      pit_stop_start      : "Включение режима ПИТ-Стоп",
      obd_data_get        : "OBD диагностики устройства",
      obd_error_clear     : "Очистка ошибок",
      get_settings        : "Получение настроек из устройства",
      dvr_output_on       : 'Включить регистратор',
      get_location        : 'Обновление координат'
    },
    commandsUni : [
      {
        id : 0,
        name : 'Используемые 1',
        list : [
          {
            name  : "arm",
            icon  : "cmd-go-arm",
            title : "Поставить на охрану"
          },
          {
            name  : "disarm",
            icon  : "cmd-disarm",
            title : "Снять с охраны"
          },
          {
            name  : "engine_start",
            icon  : "cmd-remote-start-gray",
            title : "Завести двигатель"
          },
          {
            name  : "alarm_start",
            icon  : "cmd-go-alarm",
            title : "Подать сигнал"
          },
        ]
      },
      {
        id : 1,
        name : 'Список всех команд',
        list : [
          {
            name  : "engine_stop",
            icon  : "cmd-stop-engine-gray",
            title : "Остановить двигатель"
          },
          {
            name  : "service_start",
            icon  : "cmd-go-service-start",
            title : "Активировать автосервис"
          },
          {
            name  : "service_stop",
            icon  : "cmd-go-service-stop",
            title : "Автосервис отключить"
          },
          {
            name  : "get_info",
            icon  : "cmd-get-info",
            title : "Обновить статус"
          },
          {
            name  : "alarm_stop",
            icon  : "cmd-go-alarm-stop",
            title : "Отключить сигнал"
          },
          {
            name  : "auto_hijack_start",
            icon  : "cmd-go-ahj",
            title : "Включить защита от"
          },
          {
            name  : "auto_hijack_stop",
            icon  : "cmd-go-ahj-stop",
            title : "Отключить защита от"
          },
          {
            name  : "pre_heater_start",
            icon  : "cmd-pre-heater-start",
            title : "Включить подогреватель"
          },
          {
            name  : "pre_heater_stop",
            icon  : "cmd-pre-heater-stop",
            title : "Отключить подогреватель"
          },
          {
            name  : "clear_immo",
            icon  : "cmd-clear-immo-gray",
            title : "Разрешить поездку"
          },
          {
            name  : "trunk_open",
            icon  : "cmd-open-trunk",
            title : "Открыть багажник"
          },
          {
            name  : "trunk_open",
            icon  : "cmd-close-trunk",
            title : "Закрыть багажник"
          },
          {
            name  : "door_open",
            icon  : "cmd-clear-immo",
            title : "Открыть двери"
          },
          {
            name  : "trunk_open",
            icon  : "cmd-cl-close",
            title : "Закрыть двери"
          },
          {
            name  : "prog_1",
            icon  : "cmdProg1",
            title : "Команда 1 допканал"
          },
          {
            name  : "prog_2",
            icon  : "cmdProg2",
            title : "Команда 2 допканал"
          },
          {
            name  : "prog_3",
            icon  : "cmdProg3",
            title : "Команда 3 допканал"
          },
          {
            name  : "prog_4",
            icon  : "cmdProg4",
            title : "Команда 4 допканал"
          },
          {
            name  : "prog_5",
            icon  : "cmdProg5",
            title : "Команда 5 допканал"
          },
          {
            name  : "prog_6",
            icon  : "cmdProg6",
            title : "Команда 6 допканал"
          },
          {
            name  : "prog_7",
            icon  : "cmdProg7",
            title : "Команда 7 допканал"
          },
          {
            name  : "prog_8",
            icon  : "cmdProg8",
            title : "Команда 8 допканал"
          },
        ]
      },
    ],
    commandsMobicar : [
      {
        id : 0,
        name : 'Используемые 2',
        list : [
          {
            name  : "arm",
            icon  : "cmd-go-arm",
            title : "Поставить на охрану"
          },
          {
            name  : "disarm",
            icon  : "cmd-disarm",
            title : "Снять с охраны"
          },
          {
            name    : "engine_start",
            icon    : "cmdRemoteStart",
            title   : "Завести двигатель",
            title2  : "Продлить"
          },
          {
            name  : "alarm_start",
            icon  : "cmdGoAlarm",
            title : "Подать сигнал"
          },
          {
            name : "service_start",
            icon  : "cmdGoService",
            title : 'Активировать автосервис'
          },
          {
            name : "service_stop",
            icon  : "cmdStopService",
            title : 'Автосервис отключить'
          },
        ]
      },
      {
        id : 1,
        name : 'Список всех команд',
        list : [
          { name : "alarm_stop",         icon  : "cmdGoAlarmStop",    title : 'Остановить тревогу' },
          { name : "pre_heater_start",   icon  : "cmdPreHeaterStart", title : 'Включить подогреватель' },
          { name : "pre_heater_stop",    icon  : "cmdPreHeaterStop",  title : 'Отключить подогреватель' },
          { name : "clear_immo",         icon  : "cmdClearImmo",      title : 'Разрешить поездку' },
          { name : "door_open",          icon  : "cmdCL",             title : 'Отпереть ЦЗ' },
          { name : "door_close",         icon  : "cmd-clear-immo",    title : 'Запереть ЦЗ' },
          { name : "trunk_open",         icon  : "cmdOpenTrunk",      title : 'Открыть багажник' },
          { name : "engine_stop",        icon  : "cmdStopEngine",     title : 'Остановить двигатель' },
          { name : "arm_quiet",          icon  : "cmdArmQuiet",       title : 'Тихая постановка' },
          { name : "disarm_quiet",       icon  : "cmdDisarmQuiet",    title : 'Тихое снятие' },
          { name : "ign_support_on",     icon  : "cmdIgnSupportOn",   title : 'Вкл.поддержки зажигания' },
          { name : "panic_stop",         icon  : "cmdGoAlarmStop",    title : 'Остановить Панику' },
          { name : "pit_stop_start",     icon  : "cmdPitStop",        title : 'Включение ПИТ-Стоп' },
          { name : "dvr_output_on",      icon  : "cmdReg",            title : 'Включить регистратор' },
          { name : "auto_hijack_start",  icon  : "cmd-go-ahj",        title : "Включить защита от" },
          { name : "auto_hijack_stop",   icon  : "cmd-go-ahj-stop",   title : "Отключить защита от" },
          { name : "get_location",       icon  : "GetGPSData",        title : 'Обновление координат' },
          { name : "prog_1",             icon  : "cmdProg1",          title : 'Команда 1 допканал' },
          { name : "prog_2",             icon  : "cmdProg2",          title : 'Команда 2 допканал' },
          { name : "prog_3",             icon  : "cmdProg3",          title : 'Команда 3 допканал' },
          { name : "prog_4",             icon  : "cmdProg4",          title : 'Команда 4 допканал' },
          { name : "prog_5",             icon  : "cmdProg5",          title : 'Команда 5 допканал' },
          { name : "prog_6",             icon  : "cmdProg6",          title : 'Команда 6 допканал' },
        ]
      },
    ],
    journal : {
      type : 0,
      filter : {
        url : '',
        list : []
      },
      menuItem : ''
    },
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false,
      lastState : '',
    },
    preloaders : {
      global : false
    },
    popup : {
      active : false
    }
  },
  mutations: {
    // Тип карты
    setMapType(state, type){
      state.map.type = type
    },
    setMapChoise(state){
      state.map.showChoise = !state.map.showChoise;
    },

    // Обновляем активную машину
    setActiveCar(state, index){
      if( index > -1 ){
        state.cars.current = {
          index : index,
          id : state.cars.list[index].id
        }
      }else{
        state.cars.current = {
          index : '',
          id : ''
        }
      }
    },
    setActiveCarFromMap(state, id){
      for( let i = 0; i < state.cars.list.length; i++ ){
        if( parseInt(state.cars.list[i].id) === parseInt(id) ){
          state.cars.current = {
            index : i,
            id : id
          };
          break;
        }
      }
    },
    // Обновляем список авто
    setListCar(state, list){
      state.cars.list = [];
      for( let i = 0; i < list.length; i++ ){
        let item = list[i];

        for( let j = 0; j < state.fuel_type.length; j++ ){
          if( item.fuel_type === state.fuel_type[j].val ){
            item.fuelType = state.fuel_type[j];
            break;
          }
        }

        state.cars.list.push( item );
      }
    },
    setDevice(state, data){
      Vue.set(state.cars.list[data.index], 'device', data.data);
    },

    // Данные пользователя
    setUserData(state, data){
      Vue.set(state.user, 'data', data)
    },

    // Переключение пунктов юзер меню
    setUserMenu(state, index){
      state.user.menu = index
    },
    // Включение показа деталей авто
    setCarDetailsState(state, type){
      state.panels.carDetails = type;
    },
    // Переключение состояния панели управления авто
    setControlPanel(state, index){
      state.panels.control = index;
    },
    // Пункт меню панели управления авто
    setControlPanelMenu( state, index ){
      state.panels.car = index
    },
    // Переключение состояния опционной панели
    setOptionPanel(state, status){
      state.panels.option.status = status;
    },
    // Тип панели опций
    setOptionPanelType(state, type){
      state.panels.option.type = type;
    },
    // Переключение активного пункта сеттингов
    setSettingsItem(state, index){
      state.panels.settings = index
    },

    // Устанавливаем активный элемент меню
    setJournalItem(state, data){
      state.journal.type = data.type;
      state.journal.menuItem = data.item;
    },

    //
    setHistoryDay(state, data){
      state.map.historyDay = data;
    },

    // Добавление Алерта
    setAlert(state, alert){
      state.alerts.push( alert );
      setTimeout(function () { state.alerts.splice(0, 1) }, 4000);
    },
    // Удаление Алерта
    setRemoveAlert(state, index){
      state.alerts.splice(index, 1);
    },

    // Изменили фильтр событий
    setEventsFilter(state, data){
      state.journal.filter.url = data.eventsFilterUrl;
      state.journal.filter.list = data.listFormat;
    },

    // Переключатель между основным сайтом и панелью
    setInitialPage(state) {
      state.initialPage = !state.initialPage;
    },
    // Открыть/Скрыть панель авторизации
    setLoginPanel(state){
      state.panels.login.status = !state.panels.login.status;
    },
    setLoginFormType(state, type){
      state.panels.login.type = type
    },
    setRemindData( state, data){
      state.panels.login.remind = data;
    },
    setInitialSlide( state, data ){
      state.initial.slideTo = data;
    },

    checkMobicarPro( state, data ){
      if( data ){
        if( state.cars.device[ data.id ].type !== 1 ){
          state.panels.option.status = 1;
          state.panels.option.type = 2;
          state.cars.current.index = data.index;
          state.cars.current.id = data.id;
          state.panels.carDetails = true;
          setTimeout( () => {
            state.panels.car = 4;
          }, 300 );
        }
      }else{
        for( let i = 0; i < state.cars.list.length; i++ ){
          if( state.cars.device[ state.cars.list[i].id ].type !== 1 ){
            state.panels.option.status = 1;
            state.panels.option.type = 2;
            state.cars.current.index = i;
            state.cars.current.id = state.cars.list[i].id;
            state.panels.carDetails = true;
            setTimeout( () => {
              state.panels.car = 4;
            }, 300 );

            break;
          }
        }
      }
    },

    // Изменение списка комманд
    updateCommandsList(state, commands){
      state.commands = [];
      state.commands.push( commands[0] );
      state.commands.push( commands[1] );
    },

    // Global Preloader
    toogleGlobalPreloader(state){
      state.preloaders.global = state.preloaders.global !== true;
    },

    // Popup
    togglePopup(state){
      state.popup.active = state.popup.active !== true;
    },

    // Socket
    [SOCKET_ONOPEN](state)  {
      let data = {
        'type' : 'auth',
        'data' : GET_COOKIE('userToken')
      };
      Vue.prototype.$socket.send( JSON.stringify( data ) );

      state.socket.isConnected = true;

      /*
      Ping
      setInterval(() => {
        console.log('ws ping');
        Vue.prototype.$socket.send(  JSON.stringify({ 'type' : 'ping' }) );
      }, 30000 );
      */
    },
    [SOCKET_ONMESSAGE](state, message)  {
      if( message.type === 'state' ){
        Vue.set(state.cars.state, message.car_id, message.data);
        state.cars.lastSocket.state = message;
      }else if( message.type === 'route' ){
        state.cars.lastSocket.route = message;

        if( message.data ){
          let polyline = {};
          polyline.decode = function(str, precision) {
            var index = 0,
              lat = 0,
              lng = 0,
              coordinates = [],
              shift = 0,
              result = 0,
              byte = null,
              latitude_change,
              longitude_change,
              factor = Math.pow(10, precision || 6);

            while (index < str.length) {

              // Reset shift, result, and byte
              byte = null;
              shift = 0;
              result = 0;

              do {
                byte = str.charCodeAt(index++) - 63;
                result |= (byte & 0x1f) << shift;
                shift += 5;
              } while (byte >= 0x20);

              latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

              shift = result = 0;

              do {
                byte = str.charCodeAt(index++) - 63;
                result |= (byte & 0x1f) << shift;
                shift += 5;
              } while (byte >= 0x20);

              longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

              lat += latitude_change;
              lng += longitude_change;

              coordinates.push({ 'lat' : lat / factor, 'lng' : lng / factor });
            }

            return coordinates;
          };
          let dataTail = polyline.decode( message.data.points );

          if( !state.cars.route[message.car_id] ){
            Vue.set( state.cars.route, message.car_id, message.data);
            Vue.set( state.cars.route[message.car_id], 'tail', dataTail );
          }else{
            if( message.data.is_abs === true ){
              state.cars.route[message.car_id] = [];
              state.cars.route[message.car_id] = dataTail;
            }else{
              let curRoute = message.data;
              curRoute.tail = state.cars.route[message.car_id].tail.concat( dataTail );
              state.cars.route[message.car_id] = curRoute;
            }
          }
        }
      }else if( message.type === "cmd" ){
        state.cars.lastSocket.cmd = message;
      }else if( message.type === "data" ){
        state.cars.lastSocket.data = message;
      }
    },
    [SOCKET_ONCLOSE](state)  {
      state.socket.isConnected = false;

      state.cars.state = {};
      state.cars.route = {};

      Vue.prototype.$connect();
    },
    [SOCKET_ONERROR]() {
      console.error('error');
      console.log( 'error' );
    },
    [SOCKET_RECONNECT]() {
      console.info('reconnect');
      console.log( 'reconnect' );
    },
    [SOCKET_RECONNECT_ERROR](state) {
      state.socket.reconnectError = true;
      console.log( 'reconnect_error' );
    }
  },
  actions: {
    // Выбор карты
    changeMapType : function({commit}, type){
      commit('setMapType', type)
    },
    changeMapChoise : function({commit}){
      commit('setMapChoise')
    },

    // Тыкнули на машину
    toggleActiveCar : function ({commit}, index) {
      commit('setActiveCar', index)
    },
    // Тыкнули на машину на карте
    markerMap : function ({commit}, id) {
      commit('setActiveCarFromMap', id);
    },
    // Получаем список авто
    listCar : function ({commit}, data) {
      commit('setListCar', data );
    },
    // Запрашиваем все данные по девайсу
    deviceList : function ({commit}, data) {
      commit('setDevice', data);
    },

    // Данные пользователя
    userData : function ({commit}, response) {
      let timezone = response.data.time_zone;
      let data = response.data;
      // телефон
      data.phone = data.phone.replace(/\D/g, '');
      // таймзона
      data.time_zone = {
        value: '',
        list : [
          { value : 'Pacific/Midway',                 text : '(GMT-11:00) Остров Мидуэй, Самоа' },
          { value : 'US/Hawaii',                      text : '(GMT-10:00) Гавайи' },
          { value : 'US/Alaska',                      text : '(GMT-09:00) Аляска' },
          { value : 'Canada/Pacific',                 text : '(GMT-08:00) Тихоокеанское время (США и Канада)' },
          { value : 'US/Mountain',                    text : '(GMT-07:00) Горное время (США и Канада)' },
          { value : 'US/Central',                     text : '(GMT-06:00) Центральное время (США и Канада)), Мехико' },
          { value : 'US/Eastern',                     text : '(GMT-05:00) Восточное время (США и Канада)), Богота, Лима' },
          { value : 'America/La_Paz',                 text : '(GMT-04:00) Атлантическое время (Канада)), Каракас, Ла-Пас' },
          { value : 'Canada/Newfoundland',            text : '(GMT-03:30) Ньюфаундленд' },
          { value : 'America/Argentina/Buenos_Aires', text : '(GMT-03:00) Бразилия, Буэнос-Айрес, Джорджтаун' },
          { value : 'America/Noronha',                text : '(GMT-02:00) Срединно-Атлантического' },
          { value : 'America/Scoresbysund',           text : '(GMT-01:00) Азорские острова, острова Зеленого Мыса' },
          { value : 'UTC',                            text : '(GMT 00:00) Время Западной Европе, Лондон, Лиссабон, Касабланка' },
          { value : 'Europe/Paris',                   text : '(GMT+01:00) Брюссель, Копенгаген, Мадрид, Париж' },
          { value : 'Europe/Kaliningrad',             text : '(GMT+02:00) Калининград, Киев, Южная Африка' },
          { value : 'Europe/Moscow',                  text : '(GMT+03:00) Москва, Санкт-Петербург,Багдад, Эр-Рияд' },
          { value : 'Asia/Tehran',                    text : '(GMT+03:30) Тегеран' },
          { value : 'Asia/Baku',                      text : '(GMT+04:00) Самара, Абу-Даби, Баку, Тбилиси' },
          { value : 'Asia/Kabul',                     text : '(GMT+04:30) Кабул' },
          { value : 'Asia/Yekaterinburg',             text : '(GMT+05:00) Екатеринбург, Исламабад, Карачи, Ташкент' },
          { value : 'Asia/Kolkata',                   text : '(GMT+05:30) Бомбей, Калькутта, Мадрас, Нью-Дели' },
          { value : 'Asia/Katmandu',                  text : '(GMT+05:45) Катманду' },
          { value : 'Asia/Novosibirsk',               text : '(GMT+06:00) Новосибирск,Алматы, Дакке, Коломбо' },
          { value : 'Asia/Novokuznetsk',              text : '(GMT+07:00) Новокузнецк, Бангкок, Ханой, Джакарта' },
          { value : 'Asia/Irkutsk',                   text : '(GMT+08:00) Иркутск, Пекин, Перт, Сингапур, Гонконг' },
          { value : 'Asia/Yakutsk',                   text : '(GMT+09:00) Якутск, Токио, Сеул, Осака, Саппоро' },
          { value : 'Australia/Adelaide',             text : '(GMT+09:30) Аделаида, Дарвин' },
          { value : 'Asia/Vladivostok',               text : '(GMT+10:00) Владивосток,Сахалин,Магадан,Восточная Австралия,Гуам' },
          { value : 'Antarctica/Macquarie',           text : '(GMT+11:00) Соломоновы острова, Новая Каледония' },
          { value : 'Asia/Kamchatka',                 text : '(GMT+12:00) Камчатка, Окленд, Веллингтон, Фиджи' },
        ]
      };
      for( let i = 0; i < data.time_zone.list.length; i++ ){
        if( timezone === data.time_zone.list[i].value ){
          data.time_zone.value = data.time_zone.list[i].value;
          break;
        }
      }

      commit('setUserData', data);
    },

    // Переключение меню
    userMenu : function ({commit}, index) {
      commit('setUserMenu', index);
    },
    // Тугл детали авто
    carDetailsState : function ({commit}, type) {
      commit('setCarDetailsState', type)
    },
    // Тугл панели управления авто
    controlPanel : function ({commit}, index) {
      commit('setControlPanel', index);
    },
    // Переключение меню управления авто
    controlPanelMenu : function ({commit}, index) {
      commit('setControlPanelMenu', index);
    },
    // Тугл панели опций
    optionPanel : function ({commit}, status) {
      commit('setOptionPanel', status)
    },
    // Выбор типа панели опций
    optionPanelType : function ({commit}, type) {
      commit('setOptionPanelType', type)
    },
    // Пункт Сеттингов
    settingPanel : function ({commit}, index) {
      commit('setSettingsItem', index)
    },

    // Журнал. Активный элемент
    journalRouteItem : function ({commit}, item) {
      let data = {
        item : item,
        type : 0
      };
      commit('setJournalItem', data);
    },
    journalEventItem : function ({commit}, item) {
      let data = {
        item : item,
        type : 1
      };
      commit('setJournalItem', data);
    },

    // Изменили день целиком в журнале
    changeHistoryDay : function ({commit}, data) {
      commit('setHistoryDay', data)
    },

    // Сохранение фильтров событий
    saveEventsFilter : function ({commit}, data) {
      commit('setEventsFilter', data);
    },

    // Сохранение настроек
    saveSettings : function () {
    },

    // Изменение списка комманд
    changeCommandList : function ({commit}) {
      if( GET_COOKIE('commandsList') ){
        let commands = JSON.parse( GET_COOKIE('commandsList') );

        commit('updateCommandsList', commands);
      }
    },

    // Добавление Алерта
    addAlert : function ({commit}, alert) {
      commit('setAlert', alert);
    },
    // Удаление Алерта
    delAlert : function ({commit}, index) {
      commit('setRemoveAlert', index);
    },

    // Ошибки при запросах
    errorResponse : function ({commit}, error) {
      if( error.response.data.non_field_errors !== undefined ){
        for( let i = 0; i < error.response.data.non_field_errors.length; i++ ){
          commit('setAlert', { text : error.response.data.non_field_errors[i], type : 'error' });
        }
      }else if( error.response.data.detail !== undefined ){
        commit('setAlert', { text : error.response.data.detail, type : 'error' });
      }else{
        if( typeof(error.response.data) === 'string' ){
          commit('setAlert', { text : 'Системная ошибка', type : 'error' });
          console.log( error.response.data );
        }else{
          for( let key in error.response.data ){
            commit('setAlert', { text : error.response.data[key], type : 'error' });
          }
        }
      }
    },

    // Переключили на основной сайт/панель
    toggleInitialPage : function ({commit}) {
      commit('setInitialPage');
    },
    //
    toggleLoginPanel : function ({commit}) {
      commit('setLoginPanel')
    },
    // loginFormType
    loginFormType : function ({commit}, type) {
      commit('setLoginFormType', type);
    },
    // Remind Login Data
    remindData : function ({commit}, id) {
      commit('setRemindData', id);
    },
    //
    changeInitialSlide : function ({ commit}, data ){
      commit('setInitialSlide', data);
    },

    // initialGetMobicarPro
    initialGetMobicarPro : function ({commit}, data) {
      commit('checkMobicarPro', data)
    },

    // Global Preloader
    globalPreloader : function ({commit}) {
      commit('toogleGlobalPreloader')
    },

    // Popup
    mainPopup : function ({ commit }){
      commit('togglePopup')
    }
  },
});